import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { Validators } from '@angular/forms'
import { FieldTree, form } from '@angular/forms/signals'
import { MatDialogRef } from '@angular/material/dialog'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { validoiReaktiivisesti } from 'app/_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'

export interface AreYouSureDialogData {
  rightAction: string
  text: string
  header?: string
  leftAction?: string
}

interface HyvaksyntaLomake {
  agree: boolean | null
}

@Component({
  templateUrl: './tilinpaatos-are-you-sure.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TilinpaatosAreYouSureDialog implements OnInit {
  lomake = form(signal<HyvaksyntaLomake>({ agree: null }), polku => {
    validoiReaktiivisesti(polku.agree, Validators.requiredTrue)
  })

  constructor(
    private _dialogRef: MatDialogRef<TilinpaatosAreYouSureDialog>,
    private _formValidationService: FormValidationService,
    private _kayttajaService: KayttajaService,
  ) {}

  ngOnInit() {}

  onkoVirhe<T>(kentta: FieldTree<T>, laji: string): boolean {
    return kentta()
      .errors()
      .some(virhe => virhe.kind === laji)
  }

  async replyTrue() {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      this._dialogRef.close(false)
      return
    }

    if (!this.lomake().valid()) {
      this._formValidationService.merkitseKokoLomakeKosketuksi(this.lomake)
      return
    }
    this._dialogRef.close(true)
  }
}
